import { resolveQuerySelector, setText, type QuerySelector } from './dom';

export interface ConsentDialogDeps {
  readonly onAccept: () => void;
  readonly onCancel: () => void;
  readonly querySelector?: QuerySelector;
}

export interface ConsentDialogApi {
  show(rewardText: string): void;
  focusHeading(): void;
  isHeadingFocused(): boolean;
  destroy(): void;
}

export function createConsentDialog(deps: ConsentDialogDeps): ConsentDialogApi {
  const querySelector = resolveQuerySelector(deps.querySelector);
  const consentHeading = querySelector<HTMLElement>('#ad-consent-heading');
  const consentReward = querySelector<HTMLElement>('#ad-consent-reward');
  const consentAcceptButton = querySelector<HTMLButtonElement>('#ad-consent-accept');
  const consentCancelButton = querySelector<HTMLButtonElement>('#ad-consent-cancel');

  consentAcceptButton?.addEventListener('click', deps.onAccept);
  consentCancelButton?.addEventListener('click', deps.onCancel);

  return {
    show: (rewardText) => setText(consentReward, rewardText),
    focusHeading: () => consentHeading?.focus({ preventScroll: true }),
    isHeadingFocused: () => document.activeElement === consentHeading,
    destroy: () => {
      consentAcceptButton?.removeEventListener('click', deps.onAccept);
      consentCancelButton?.removeEventListener('click', deps.onCancel);
    },
  };
}
